import { muiTheme } from '@tassat/payments-themes';

const statedBackgroundColor = (state, theme: typeof muiTheme) => {
    if (state.isSelected) {
        return theme?.app?.clientTheme.colors.primaryColor || '#375073';
    }

    if (state.isFocused) {
        return theme?.app?.clientTheme.colors.buttons.primaryHover || '#bec6d4';
    }

    return null;
};

export const monthStyles = (theme: typeof muiTheme) => ({
    container: (base) => ({
        ...base,
        padding: '.25rem'
    }),
    control: (base) => ({
        ...base,
        height: '24px',
        border: 'none' as 'none',
        boxShadow: 'none' as 'none',
        backgroundColor: 'transparent' as 'transparent'
    }),
    valueContainer: (base) => ({
        ...base,
        height: '24px',
        width: '78px',
        fontSize: '.9rem'
    }),
    menu: (base) => ({
        ...base,
        margin: '20px 1px 1px 1px',
        fontSize: '.8rem'
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none' as 'none'
    }),
    option: (base, state) => {
        const backgroundColor = statedBackgroundColor(state, theme);

        return {
            ...base,
            color: (state.isFocused || state.isSelected) ?
                (theme?.app?.applicationColors.enumColors.white || '#FFFFFF')
                : null,
            backgroundColor
        };
    },
    singleValue: (base) => ({
        ...base,
        overflow: 'none' as 'none'
    })
});

export const yearStyles = (theme: typeof muiTheme) => ({
    container: (base) => ({
        ...base,
        padding: '.25rem'
    }),
    control: (base) => ({
        ...base,
        height: '24px',
        border: 'none' as 'none',
        boxShadow: 'none' as 'none',
        backgroundColor: 'transparent' as 'transparent'
    }),
    valueContainer: (base) => ({
        ...base,
        height: '24px',
        width: '44px',
        fontSize: '.9rem'
    }),
    menu: (base) => ({
        ...base,
        margin: '20px 1px 1px 1px',
        fontSize: '.8rem'
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none' as 'none'
    }),
    option: (base, state) => {
        const backgroundColor = statedBackgroundColor(state, theme);

        return {
            ...base,
            color: (state.isFocused || state.isSelected) ?
                (theme?.app?.applicationColors.enumColors.white || '#FFFFFF')
                : null,
            backgroundColor
        };
    },
    singleValue: (base) => ({
        ...base,
        overflow: 'none' as 'none'
    })
});